(function ($, Cobalt, undefined) {
	var initialize = function () {
		if ($("div.module.user-edit").length == 0 && $(".user-action-legacysub-resync").length == 0) {
			return;
		}

		$("#tab-legacysubscription-history").delegate(".user-action-legacysub-comp", "click", function (e) {
			e.preventDefault();
			var a = $(this);
			var href = a.attr("href");

			var monthsLabel = $("<label>How many months do you wish to comp the subscription?</label>");
			var monthsInput = $("<input type=\"text\" size=\"4\"/>");
			var monthsRow = $("<div>");
			monthsRow.append(monthsLabel);
			monthsRow.append(monthsInput);
			// var br = $("<br/>");
			var button = $("<a class=\"button\"><span>Issue Comp</span></a>");

			var status = $("<div>");
			status.html("Issuing comp...");
			status.hide();

			var promptControls = $("<div>");
			promptControls.append(monthsRow);
			//promptControls.append(br);
			promptControls.append(button);
			promptControls.append(status);

			var div = $("<div>");
			div.append(promptControls);
			div.show();
			div.dialog({
				draggable: false,
				title: "Comp Subscription",
				modal: true,
				resizable: false,
				dialogClass: 'modal credit-subscription-modal'
			});

			div.parent().center({ sizeToWindow: true, maxWidth: 425, maxHeight: 90 });

			button.click(function () {
				status.show();
				button.addClass("disabled");

				var url = href + "?m=" + monthsInput.val();
				$.ajax({
					type: "POST",
					contentType: "application/json; charset=utf-8",
					url: url,
					dataType: "json",
					success: function (data) {

						if (data.IsSuccessful) {
							alert("The subscription has been credited. The page will now reload.");
							self.location.reload();
						}
						else {
							alert(data.Message);
						}
						div.dialog("destroy");
					}
				});
			});
		});

		$("#tab-legacysubscription-history").delegate(".user-action-legacysub-resync", "click", function (e) {
			e.preventDefault();
			var a = $(this);
			var url = $(this).attr("href");
			$.ajax({
				type: "POST",
				contentType: "application/json; charset=utf-8",
				url: url,
				dataType: "json",
				success: function (data) {

					if (data.IsSuccessful) {
						alert("Legacy Subscriptions for this account have been resynced with the Payment Service. The page will now reload.");
						self.location.reload();
					}
					else {
						alert(data.Message);
					}
				}
			});
		});


	};

	Cobalt.LegacyPayment = {
		initialize: function () {
			initialize();
		}
	};
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.LegacyPayment.js